/* eslint-disable import/prefer-default-export */
import { toValue } from '@vueuse/core';
import { useUpcPreselect } from '@modules/upc';

/**
 *
 * @param {Partial<Record<import('../../types').GIFT_CARD_FIELDS, string>>} values
 * @param {import('@vueuse/core').MaybeRefOrGetter<null | number | string>} selectedGift
 */
export const useGiftConsolidatedPreselect = (values, selectedGift) => {
  useUpcPreselect();
  const value = toValue(selectedGift);
  values.giftCardAmount = value === null ? '' : value.toString();
};
